import { BaseSerializer } from "./baseSerializer";
import {GuidePost} from "../guidePost.model.ts";


export class GuidePostSerializer extends BaseSerializer {

    public deserialize( data: any ): any {

        const gp = new GuidePost();

        this._copyAttributes(gp, data);

        return gp;

    }

}
